<template>
  <el-row :gutter="16">
    <el-col :span="24">
      <div class="moduleStyle mb16 plr24">
        <div class="moduleStyle_title">
          <h3 class="workbench-title">
            总资产<span
              >
              <template v-if="comp_level == 0 ">总资产=自营库存资产+资金账号总金额+应收款-应付款-客户账户+供应商账户+加盟库存资产+未结算加盟账单</template>
              <template v-else-if="comp_level == 1 ">总资产=自营库存资产+资金账号总金额+应收款-应付款-客户账户+供应商账户-加盟库存资产-未结算加盟账单</template>
              <template v-else-if="comp_level == 2 ">总资产=自营库存资产+资金账号总金额+应收款-应付款-客户账户+供应商账户</template>
             </span
            >
          </h3>
          <div>
            <!-- <el-button
              type="primary"
              size="small"
              icon="el-icon-refresh-left"
              @click="updateTotalCapital()"
              >更新总资本</el-button
            > -->
            <el-button
              type="primary"
              size="small"
              icon="el-icon-refresh-left"
              @click="getlist()"
              >刷新</el-button
            >
          </div>
        </div>
        <!-- 采购数据汇总 -->
        <div class="procurementDataSummary workbenchSummary">
          <ul>
            <li>
              <div class="summaryTitle">
                总资产
                <el-popover
                  placement="top-start"
                  class="tip_mr"
                  trigger="click"
                >
                  <ul class="calculationFormula">
                    <li>
                      <span>{{ summarizeData.result_all }}</span>
                      <p>总资产</p>
                    </li>
                    <li>=</li>
                    <li>
                      <span>{{ summarizeData.total_price }}</span>
                      <p>自营库存资产</p>
                    </li>
                    <li>+</li>
                    <li>
                      <span>{{ summarizeData.total_account }}</span>
                      <p>资金账号总金额</p>
                    </li>
                    <li>+</li>
                    <li>
                      <span>{{ summarizeData.total_get }}</span>
                      <p>应收款</p>
                    </li>
                    <li>-</li>
                    <li>
                      <span>{{ summarizeData.total_pay }}</span>
                      <p>应付款</p>
                    </li>
                    <li>-</li>
                    <li>
                      <span>{{ summarizeData.user_money }}</span>
                      <p>客户账户</p>
                    </li>
                    <li>+</li>
                    <li>
                      <span>{{ summarizeData.supplier_money }}</span>
                      <p>供应商账户</p>
                    </li>
                    <template v-if="comp_level==0">
                      <li>+</li>
                    <li>
                      <span>{{ summarizeData.result_all_join }}</span>
                      <p>加盟库存资产</p>
                    </li>
                    <li>+</li>
                    <li>
                      <span>{{ summarizeData.total_get_join }}</span>
                      <p>未结算加盟账单</p>
                    </li>
                    </template>
                    <template v-else-if="comp_level==1">
                      <li>-</li>
                    <li>
                      <span>{{ summarizeData.result_all_join }}</span>
                      <p>加盟库存资产</p>
                    </li>
                    <li>-</li>
                    <li>
                      <span>{{ summarizeData.total_get_join }}</span>
                      <p>未结算加盟账单</p>
                    </li>
</template>
<template v-else-if="comp_level==2">

</template>
                   
                  </ul>
                  <img src="../../assets/images/tip.png" slot="reference" />
                </el-popover>
              </div>
              <div class="today summaryLine">
                <p>{{ summarizeData.result_all }}</p>
              </div>
            </li>

            <li>
              <div class="summaryTitle">
                总资产每日变化
                <el-popover
                  placement="top-start"
                  class="tip_mr"
                  trigger="click"
                >
                  <ul class="calculationFormula">
                    <li>
                      <span>{{ summarizeData.def_result }}</span>
                      <p>总资产每日变化</p>
                    </li>
                    <li>=</li>
                    <li>
                      <span>{{ summarizeData.result_all }}</span>
                      <p>当前总资产</p>
                    </li>
                    <li>-</li>
                    <li>
                      <span>{{ summarizeData.yesterday_result }}</span>
                      <p>昨日总资产</p>
                    </li>
                  </ul>
                  <img src="../../assets/images/tip.png" slot="reference" />
                </el-popover>
              </div>
              <div class="today summaryLine">
                <p>{{ summarizeData.def_result }}</p>
              </div>
            </li>

            <li>
              <div class="summaryTitle">
                当日净毛利
                <el-popover
                  placement="top-start"
                  class="tip_mr"
                  trigger="click"
                >
                  <ul class="calculationFormula">
                    <li>
                      <span>{{ summarizeData.daily_money_def_addother }}</span>
                      <p>当日净毛利</p>
                    </li>
                    <li>=</li>
                    <li>
                      <span>{{ summarizeData.JY_money_def }}</span>
                      <p>经营毛利</p>
                    </li>
                    <li>+</li>
                    <li>
                      <span>{{ summarizeData.today_other_payget }}</span>
                      <p>其它收益</p>
                    </li>
                    <li v-if="comp_level==0">+</li>
                    <li v-if="comp_level==0">
                      <span>{{ summarizeData.money_def_join }}</span>
                      <p>加盟毛利</p>
                    </li>
                  </ul>
                  <img src="../../assets/images/tip.png" slot="reference" />
                </el-popover>
              </div>
              <div class="summaryLine">
                <p>
                  {{ summarizeData.daily_money_def_addother }}
                </p>
              </div>
            </li>

            <li>
              <div class="summaryTitle">
                经营净毛利
                <el-popover
                  placement="top-start"
                  class="tip_mr"
                  trigger="click"
                >
                  <ul class="calculationFormula">
                    <li>
                      <span>{{ summarizeData.JY_money_def }}</span>
                      <p>经营净毛利</p>
                    </li>
                    <li>=</li>
                    <li>
                      <span>{{ summarizeData.daily_money_def_Normal }}</span>
                      <p>常</p>
                    </li>
                    <li>+</li>
                    <li>
                      <span>{{
                        summarizeData.daily_money_def_Normal_smoke
                      }}</span>
                      <p>烟</p>
                    </li>
                    <li>+</li>
                    <li>
                      <span>{{ summarizeData.trance_money_get }}</span>
                      <p>运入</p>
                    </li>
                    <li>-</li>
                    <li>
                      <span>{{ summarizeData.trance_money_pay }}</span>
                      <p>运出</p>
                    </li>
                  </ul>
                  <img src="../../assets/images/tip.png" slot="reference" />
                </el-popover>
              </div>
              <div class="summaryLine">
                <p>
                  {{ summarizeData.JY_money_def }}
                </p>
              </div>
            </li>

            <li>
              <div class="summaryTitle">常规品毛利</div>
              <div class="summaryLine">
                <p>{{ summarizeData.daily_money_def_Normal }}</p>
              </div>
            </li>
            <li>
              <div class="summaryTitle">烟毛利</div>
              <div class="summaryLine">
                <p>{{ summarizeData.daily_money_def_Normal_smoke }}</p>
              </div>
            </li>
            <li v-if="comp_level==0"> 
              <div class="summaryTitle">加盟毛利</div>
              <div class="summaryLine">
                <p>{{ summarizeData.money_def_join }}</p>
              </div>
            </li>
            <li>
              <div class="summaryTitle">
                其它收益
                <el-popover
                  placement="top-start"
                  class="tip_mr"
                  trigger="click"
                >
                  <ul class="calculationFormula">
                    <li>
                      <span>{{ summarizeData.today_other_payget }}</span>
                      <p>其它收益</p>
                    </li>
                    <li>=</li>
                    <li>
                      <span>{{ summarizeData.today_other_get }}</span>
                      <p>额外收入</p>
                    </li>
                    <li>-</li>
                    <li>
                      <span>{{ summarizeData.today_other_pay }}</span>
                      <p>额外支出</p>
                    </li>
                  </ul>
                  <img src="../../assets/images/tip.png" slot="reference" />
                </el-popover>
              </div>
              <div class="summaryLine">
                <p>
                  {{
                    parseFloat(
                      summarizeData.today_other_get -
                        summarizeData.today_other_pay
                    ).toFixed(2)
                  }}
                </p>
              </div>
            </li>
            <li>
                <div class="summaryTitle">
                  临期商品数
                </div>
                <div class="summaryLine">
                  <a href="index.html#/productShelfLife">
                  <p style="color: #2E7FFF;">
                    {{
                      linqi_num
                    }}
                  </p ></a >
                </div>
            </li>
          </ul>
        </div>
      </div>
    </el-col>
    <el-col :span="24">
      <div class="moduleStyle mb16 plr24">
        <h3 class="workbench-title">门店指标</h3>
        <div class="table workbench_table">
          <el-table
            header-cell-class-name="headerCellStyle"
            cell-class-name="cellStyle"
            :data="tradeData"
            style="width: 100%"
          >
            <el-table-column
              width="150"
              prop="name"
              label="门店名称"
              fixed="left"
            />
            <el-table-column width="100" prop="username" label="店长" />
            
            <!-- 动态指标列 -->
            <template v-for="def in indicatorDefs">
              <el-table-column 
                :key="def.indicator_code + '_target'"
                width="120" 
                :label="def.indicator_name + '-指标'"
              >
                <template slot-scope="scope">
                  {{ getIndicatorValue(scope.row, def.indicator_code, 'target') }}
                </template>
              </el-table-column>
              <el-table-column 
                :key="def.indicator_code + '_rate'"
                width="120" 
                :label="def.indicator_name + '-完成比例'"
              >
                <template slot-scope="scope">
                  {{ getIndicatorRate(scope.row, def.indicator_code) }}
                </template>
              </el-table-column>
            </template>
            
            <!-- 整体完成比例 -->
            <el-table-column width="150" prop="allrate" label="整体完成比例">
              <template slot-scope="scope">
                {{ scope.row.allrate == "-" ? "-" : scope.row.allrate + "%" }}
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </el-col>
    <el-col :span="24">
      <div class="moduleStyle mb16 plr24">
        <h3 class="workbench-title">今日销售绩效</h3>
        <div class="table workbench_table">
          <el-table
            header-cell-class-name="headerCellStyle"
            cell-class-name="cellStyle"
            :data="tableData"
            style="width: 100%"
          >
            <el-table-column prop="part_name" label="部门" />
            <el-table-column prop="name" label="员工" />
            <el-table-column prop="money_def" label="今日毛利" />
            <el-table-column prop="today_other_get" label="人均额入" />
            <el-table-column prop="today_other_pay" label="人均额出" />
            <el-table-column prop="real_money_def" label="实际毛利" />
            <el-table-column prop="single_real_money_def" label="个人毛利" />
          </el-table>
        </div>
      </div>
    </el-col>

    <el-dialog
      title="更新总资本"
      :visible.sync="dialogVisible"
      width="400px"
      :close-on-click-modal="false"
      custom-class="addProductPopUpWindow"
    >
      <el-form label-position="top" size="small">
        <el-form-item label="更新日期">
          <el-date-picker
            v-model="updateDate"
            style="width: 100%"
            value-format="yyyy-MM-dd"
            format="yyyy-MM-dd"
            type="date"
            placeholder="请选择更新日期"
          >
          </el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button size="small" @click="dialogVisible = false">取 消</el-button>
        <el-button size="small" type="primary" @click="confirmUpdate"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </el-row>
</template>

<script>
import {
  getAllInfo,
  userSellInfo,
  getshoptradelist,
  getLinqi,
  getIndicatorDefinitions,
} from "@/api/basicConfiguration";
export default {
  name: "workbench",
  data() {
    return {
      compId: null,
      userId: null,
      roleId: null,
      total_num: 0,
      comp_level:0,
      summarizeData: {},
      linqi_num:0,
      // 列表组件参数
      basicListconfig: {
        loading: false,
      },
      tableData: [],
      tradeData: [],
      indicatorDefs: [], // 指标定义列表
      dialogVisible: false,
      updateDate: "",
    };
  },

  created() {
    this.compId = this.$store.getters.userInfo.compId;
    this.userId = this.$store.getters.userInfo.userId;
    this.roleId = this.$store.getters.userInfo.roleId;
    this.comp_level = this.$store.getters.userInfo.comp_level;
    var menulist = this.$store.getters.userInfo.userMenuList;
    console.log(this.$store.getters.userInfo);
    if (!menulist.includes("首页") && this.roleId == 4) {
      this.$router.push("/employeeindex");
    }
    this.updateDate = this.$getCurrent(2);
    this.getIndicatorDefs(); // 先获取指标定义
    this.getlist(); // 再拉数据
  },

  methods: {
    // 获取指标定义
    getIndicatorDefs() {
      getIndicatorDefinitions().then((res) => {
        if (res.code == 1) {
          this.indicatorDefs = res.data || [];
        }
      });
    },
    // 获取指标值
    getIndicatorValue(row, code, type) {
      if (!row.indicators || !row.indicators[code]) return '-';
      if (type === 'target') {
        return row.indicators[code].target_value || '-';
      }
      return '-';
    },
    // 获取指标完成比例
    getIndicatorRate(row, code) {
      if (!row.indicators || !row.indicators[code]) return '-';
      const rateKey = code + '_rate';
      return row[rateKey] && row[rateKey] !== '-' ? row[rateKey] + '%' : '-';
    },
    confirmUpdate() {},
    // 更新总资产
    updateTotalCapital() {
      this.dialogVisible = true;
    },
    // 获取列表内容
    getlist() {
      this.basicListconfig.loading = true;
      getshoptradelist().then((res) => {
        console.log(res);
        if (res.code == 1) {
          this.tradeData = res.list;
        } else {
          this.$message.error(res.data.msg);
        }
      });
    getLinqi({comp_id:this.$store.getters.userInfo.compId}).then((res) => {
        //console.log(res);
        if (res.code == 1) {
          this.linqi_num= res.count;
        } else {

          this.$message.error(res.data.msg);
        }
      });
      getAllInfo().then((res) => {
        if (res.code == 1) {
          this.basicListconfig.loading = false;

          this.summarizeData = res;
          let msg = "";
          if (res.error_item > "") {
            msg += "下列产品库存可能异常：" + res.error_item + "<br/>";
          }

          let def =
            parseFloat(res.def_result) -
            parseFloat(res.daily_money_def_addother);

          if (Math.abs(def) > 1) {
            msg += "注意：资产差值异常：" + def.toFixed(2) + "<br/>";
          }
          if (msg) {
            this.$message({
              message: msg,
              dangerouslyUseHTMLString: true,
              type: "error",
            });
          }
        } else {
          this.basicListconfig.loading = false;
          this.$message.error(res.msg);
        }
      });

      this.basicListconfig.loading = true;
      userSellInfo().then((res) => {
        console.log(res);
        if (res.code == 1) {
          this.basicListconfig.loading = false;
          this.tableData = res.data;
          this.total_num = res.count;
        } else {
          this.basicListconfig.loading = false;
          this.$message.error(res.data.msg);
        }
      });
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/workbench/index.vue